import { AppConfigProvider } from '@utazzo/ui';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import React from 'react';
import { Toaster } from 'sonner';

import { env } from '@/env';
import { AppQueryProvider } from '@/providers/query-client';
import { AppRouter } from '@/router';

/**
 * Composition root. Provider order matters:
 *   1. QueryClient (needed by AppConfigProvider's useQuery)
 *   2. AppConfig (must hydrate before anything renders)
 *   3. NuqsAdapter (URL state - must wrap any component using useQueryStates)
 *   4. Router (consumes config-driven routes + URL state)
 *   5. Toaster (overlay, last so it's on top)
 */
export const App = (): React.JSX.Element => (
  <AppQueryProvider>
    {/* applyRuntimeTheme=false: the admin owns its design system (Vercel/Linear
        zinc tokens in styles/globals.css). The website's CMS branding theme
        must NOT override admin tokens. */}
    <AppConfigProvider
      apiBaseUrl={env.VITE_API_BASE_URL}
      applyRuntimeTheme={false}
      bootTimeoutMs={
        env.VITE_ENVIRONMENT === 'development'
          ? Math.max(env.VITE_APP_BOOT_TIMEOUT_MS, 60_000)
          : env.VITE_APP_BOOT_TIMEOUT_MS
      }
    >
      <NuqsAdapter>
        <AppRouter />
      </NuqsAdapter>
      <Toaster richColors closeButton position="top-right" />
    </AppConfigProvider>
  </AppQueryProvider>
);
